'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UITable',

  propTypes: {
    bordered: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    condensed: _react.PropTypes.bool.isRequired,
    flush: _react.PropTypes.bool.isRequired,
    hover: _react.PropTypes.bool.isRequired,
    responsive: _react.PropTypes.bool.isRequired,
    responsiveWrapperClassName: _react.PropTypes.string,
    truncated: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bordered: true,
      condensed: false,
      flush: false,
      hover: true,
      responsive: true,
      truncated: false
    };
  },
  getClassName: function getClassName(_ref) {
    var bordered = _ref.bordered,
        className = _ref.className,
        condensed = _ref.condensed,
        flush = _ref.flush,
        hover = _ref.hover,
        truncated = _ref.truncated;

    return (0, _reactUtils.classNames)('table private-table', className, {
      'table-bordered private-table--bordered': bordered,
      'table-condensed private-table--condensed': condensed,
      'private-table--flush': flush,
      'table-hover private-table--hover': hover,
      'table-truncated private-table--truncated': truncated
    });
  },
  renderTable: function renderTable(_ref2, _ref3) {
    var children = _ref2.children,
        rest = _ref2.rest;
    var computedClassName = _ref3.computedClassName;

    return _react2.default.createElement(
      'table',
      _extends({}, rest, { className: computedClassName }),
      children
    );
  },
  renderResponsiveTable: function renderResponsiveTable(renderedTable, responsiveWrapperClassName, flush) {
    return _react2.default.createElement(
      _UISection2.default,
      {
        className: (0, _reactUtils.classNames)(responsiveWrapperClassName, 'table-responsive', 'private-scroll__wrapper--tables', {
          'private-scroll__wrapper--flush': flush
        }),
        overhang: true
      },
      renderedTable
    );
  },
  render: function render() {
    var _props = this.props,
        bordered = _props.bordered,
        children = _props.children,
        className = _props.className,
        condensed = _props.condensed,
        flush = _props.flush,
        hover = _props.hover,
        responsive = _props.responsive,
        responsiveWrapperClassName = _props.responsiveWrapperClassName,
        truncated = _props.truncated,
        rest = _objectWithoutProperties(_props, ['bordered', 'children', 'className', 'condensed', 'flush', 'hover', 'responsive', 'responsiveWrapperClassName', 'truncated']);

    var computedClassName = this.getClassName({
      bordered: bordered,
      className: className,
      condensed: condensed,
      flush: flush,
      hover: hover,
      truncated: truncated
    });
    var renderedTable = this.renderTable({ children: children, rest: rest }, { computedClassName: computedClassName });
    if (responsive) {
      return this.renderResponsiveTable(renderedTable, responsiveWrapperClassName, flush);
    }
    return renderedTable;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/table/UITable.js
// module id = 178
// module chunks = 0